<template>
  <section class="hero bg-gradient-primary text-white position-relative overflow-hidden py-6">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="mb-5">
            <span class="badge bg-light text-primary mb-3">Software Gestionale Integrato</span>
            <h1 class="display-4 fw-bold mb-4">
              Auto e Immobili: un'unica piattaforma, infinite possibilità
            </h1>
            <p class="lead mb-4 opacity-90">
              Gestisci in modo efficiente la tua attività di compravendita auto e immobili con un software
              completamente personalizzabile. Dalla gestione documentale alle notifiche automatiche,
              tutto ciò che ti serve in un unico strumento.
            </p>
            <div class="d-flex gap-3">
              <router-link :to="{name: 'contact'}" class="btn btn-light btn-lg px-4">
                Contattaci
              </router-link>
            </div>
          </div>
          <div class="key-features mt-5 mb-5">
            <div class="row g-4">
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <i class="bi bi-speedometer2 h4 mb-0 me-3"></i>
                  <div>
                    <h6 class="mb-1">Dashboard Personalizzata</h6>
                    <p class="small mb-0">Per ogni ruolo e utente</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <i class="bi bi-bell h4 mb-0 me-3"></i>
                  <div>
                    <h6 class="mb-1">Sistema di Notifiche</h6>
                    <p class="small mb-0">Scadenze sempre sotto controllo</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <i class="bi bi-file-earmark-text h4 mb-0 me-3"></i>
                  <div>
                    <h6 class="mb-1">Gestione Documentale</h6>
                    <p class="small mb-0">Tutti i documenti organizzati</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <i class="bi bi-gear h4 mb-0 me-3"></i>
                  <div>
                    <h6 class="mb-1">100% Personalizzabile</h6>
                    <p class="small mb-0">Adattabile alle tue esigenze</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="hero-image position-relative">
            <img
              src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop"
              alt="Dashboard Software Gestionale"
              class="img-fluid rounded-4 shadow-lg"
            >
            <div class="floating-stats bg-white p-4 rounded-4 shadow-lg position-absolute" style="bottom: -2rem; right: 2rem;">
              <div class="d-flex gap-4">
                <div class="text-center">
                  <h4 class="text-primary mb-0">2in1</h4>
                  <small class="text-muted">Gestione Integrata</small>
                </div>
                <div class="text-center">
                  <h4 class="text-primary mb-0">100%</h4>
                  <small class="text-muted">Personalizzabile</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Nuova sezione: Vantaggi Chiave -->
  <section class="key-benefits py-5">
    <div class="container">
      <div class="text-center mb-5">
        <h2 class="display-5 fw-bold">Un Software, Due Mondi</h2>
        <p class="lead text-muted">Unisci la gestione auto e immobiliare in un'unica piattaforma intelligente</p>
      </div>

      <div class="row g-4">
        <div class="col-md-6">
          <div class="benefit-card h-100 bg-white p-4 rounded-4 shadow-sm">
            <div class="d-flex align-items-center mb-4">
              <div class="benefit-icon bg-primary-subtle text-primary rounded-3 p-3 me-3">
                <i class="bi bi-car-front h3 mb-0"></i>
              </div>
              <h3 class="mb-0">Gestione Auto</h3>
            </div>
            <ul class="list-unstyled mb-0">
              <li class="mb-3 d-flex align-items-center">
                <i class="bi bi-check-circle-fill text-primary me-2"></i>
                Gestione parco auto completa
              </li>
              <li class="mb-3 d-flex align-items-center">
                <i class="bi bi-check-circle-fill text-primary me-2"></i>
                Calendario integrato per manutenzioni
              </li>
              <li class="mb-3 d-flex align-items-center">
                <i class="bi bi-check-circle-fill text-primary me-2"></i>
                Gestione documenti veicoli
              </li>
            </ul>
          </div>
        </div>

        <div class="col-md-6">
          <div class="benefit-card h-100 bg-white p-4 rounded-4 shadow-sm">
            <div class="d-flex align-items-center mb-4">
              <div class="benefit-icon bg-primary-subtle text-primary rounded-3 p-3 me-3">
                <i class="bi bi-building h3 mb-0"></i>
              </div>
              <h3 class="mb-0">Gestione Immobili</h3>
            </div>
            <ul class="list-unstyled mb-0">
              <li class="mb-3 d-flex align-items-center">
                <i class="bi bi-check-circle-fill text-primary me-2"></i>
                Gestione portfolio immobiliare
              </li>
              <li class="mb-3 d-flex align-items-center">
                <i class="bi bi-check-circle-fill text-primary me-2"></i>
                Calendario integrato per appuntamenti
              </li>
              <li class="mb-3 d-flex align-items-center">
                <i class="bi bi-check-circle-fill text-primary me-2"></i>
                Gestione documentale completa
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Nuova sezione: Come Funziona -->
  <section class="how-it-works py-7">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <span class="badge bg-primary-subtle text-primary mb-3">Processo Semplice</span>
          <h2 class="display-5 fw-bold mb-4">Come Iniziare</h2>
          <div class="steps">
            <div class="step d-flex mb-4">
              <div class="step-number rounded-circle d-flex align-items-center justify-content-center me-3">1</div>
              <div>
                <h4>Richiedi una Demo</h4>
                <p class="text-muted mb-0">Contattaci per una dimostrazione personalizzata</p>
              </div>
            </div>
            <div class="step d-flex mb-4">
              <div class="step-number rounded-circle d-flex align-items-center justify-content-center me-3">2</div>
              <div>
                <h4>Personalizzazione</h4>
                <p class="text-muted mb-0">Configuriamo il software secondo le tue esigenze</p>
              </div>
            </div>
            <div class="step d-flex">
              <div class="step-number rounded-circle d-flex align-items-center justify-content-center me-3">3</div>
              <div>
                <h4>Formazione</h4>
                <p class="text-muted mb-0">Ti aiutiamo a partire con il piede giusto</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <img
            src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&h=400&fit=crop"
            alt="Come funziona"
            class="img-fluid rounded-4 shadow-lg"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.hero {
  background: #219ebc;
  color: #fff;
}

.badge {
  background: #ffb703 !important;
  color: #023047 !important;
}

.btn-light {
  background: #ffb703;
  color: #023047;
  border: none;
}

.btn-light:hover {
  background: #fb8500;
  color: #023047;
}

.key-features i {
  color: #ffb703;
}

.floating-stats {
  background: #fff;
  border: 2px solid #8ecae6;
}

.text-primary {
  color: #ffb703 !important;
}

.icon-box {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.floating-stats {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
}

.benefit-card {
  transition: transform 0.3s ease;
  border: 1px solid rgba(0,0,0,0.05);
}

.benefit-card:hover {
  transform: translateY(-5px);
}

.benefit-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-number {
  width: 40px;
  height: 40px;
  min-width: 40px;
  font-weight: bold;
  background: #219ebc !important;
  color: #fff;
}

.py-7 {
  padding-top: 3rem;
  padding-bottom: 5rem;
}

/* Animazioni */
@keyframes slideInUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.benefit-card {
  animation: slideInUp 0.6s ease forwards;
}

.benefit-card:nth-child(2) {
  animation-delay: 0.2s;
}

.step {
  animation: slideInUp 0.6s ease forwards;
}

.step:nth-child(2) {
  animation-delay: 0.2s;
}

.step:nth-child(3) {
  animation-delay: 0.4s;
}

.text-primary {
  color: #219ebc !important;
}
</style>
